// extracted by mini-css-extract-plugin
export default {"homeBanner":"homeBanner_homeBanner__CkVKz","homeText":"homeBanner_homeText__TD+gp","image":"homeBanner_image__yG6tz"};